import { render, staticRenderFns } from "./GeneralTermList.vue?vue&type=template&id=61ce6bb0&"
import script from "./GeneralTermList.vue?vue&type=script&lang=ts&"
export * from "./GeneralTermList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports